import prefixAll from 'inline-style-prefixer/static';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  requestVideoPlayerCurrentTime,
  requestVideoPlayerPause,
} from 'actions/videoPlayer';
import {
  MIN_TRIM_RANGE_LENGTH,
  TRIM_BOUND_LOWER,
  TRIM_BOUND_UPPER,
} from 'constants/trimming';
import {
  updateCurrentTrimRangeCreator,
  updateSelectedTrimBoundCreator,
} from 'creators/trimming';
import { getBoundingRange, getNewTrimBoundTime } from 'utilities/trimming';

import TrimFlag, {
  EXPANDED_FLAG_WIDTH,
  FLAG_LEFT_HALF,
  FLAG_RIGHT_HALF,
} from './trim-flag';

import './styles.less';

const PLAY_SCRUBBER_WIDTH = 7;

class TrimRangeEditBar extends Component {
  static gradientClassName = 'trim-range-edit-gradient';

  boundingRange = getBoundingRange(
    this.props.currentTrimRange,
    this.props.trimRanges,
    this.props.duration * 1000
  );

  render() {
    const {
      currentTrimRange,
      duration,
      selectedTrimBound,
      slider,
    } = this.props;

    const trimTimeLength = currentTrimRange.to - currentTrimRange.from;
    const percentageWidth = trimTimeLength / 1000 / duration;
    const leftProgress = currentTrimRange.from / 1000 / duration;

    const leftTransform =
      leftProgress * slider.clientWidth +
      Math.round(0.5 * PLAY_SCRUBBER_WIDTH - 1);

    const style = {
      transform: `translateX(${leftTransform}px)`,
    };

    const gradientWidth =
      percentageWidth * slider.clientWidth - PLAY_SCRUBBER_WIDTH + 1;

    const gradientStyles = {
      width: `${gradientWidth}px`,
    };

    // keep the flags visually within the iframe
    let leftFlagVisualHalf = FLAG_RIGHT_HALF;

    let rightFlagVisualHalf = FLAG_RIGHT_HALF;

    const absoluteLeft = slider.getBoundingClientRect().left + leftTransform;
    const absoluteRight = absoluteLeft + gradientWidth;

    if (absoluteLeft > absoluteRight - EXPANDED_FLAG_WIDTH) {
      leftFlagVisualHalf = FLAG_LEFT_HALF;
    }

    if (absoluteRight > window.innerWidth - EXPANDED_FLAG_WIDTH) {
      rightFlagVisualHalf = FLAG_LEFT_HALF;
    }

    const leftFlagExpanded = selectedTrimBound === TRIM_BOUND_LOWER;
    const rightFlagExpanded = selectedTrimBound === TRIM_BOUND_UPPER;

    return (
      <div
        className="video-player-trim-range-edit-bar"
        style={prefixAll(style)}
      >
        <TrimFlag
          visualHalf={leftFlagVisualHalf}
          half={FLAG_LEFT_HALF}
          time={currentTrimRange.from}
          boundingRange={this.boundingRange}
          currentTrimRange={currentTrimRange}
          expandScrubber={leftFlagExpanded}
          onClick={this.handleClick}
          onMouseEnter={this.handleFlagMouseEnter}
          onMouseLeave={this.handleFlagMouseLeave}
          onMouseDown={this.handleFlagMouseDown}
          onUpdateTime={this.handleFlagUpdateTime}
          updateSelectedTrimBoundCreator={updateSelectedTrimBoundCreator}
        />
        <div
          style={gradientStyles}
          className={this.constructor.gradientClassName}
        />
        <TrimFlag
          visualHalf={rightFlagVisualHalf}
          half={FLAG_RIGHT_HALF}
          time={currentTrimRange.to}
          boundingRange={this.boundingRange}
          currentTrimRange={currentTrimRange}
          expandScrubber={rightFlagExpanded}
          onClick={this.handleClick}
          onMouseEnter={this.handleFlagMouseEnter}
          onMouseLeave={this.handleFlagMouseLeave}
          onMouseDown={this.handleFlagMouseDown}
          onUpdateTime={this.handleFlagUpdateTime}
          updateSelectedTrimBoundCreator={updateSelectedTrimBoundCreator}
        />
      </div>
    );
  }

  handleClick(e) {
    e.preventDefault();
  }

  handleFlagMouseEnter = half => {
    const trimBound =
      half === FLAG_LEFT_HALF ? TRIM_BOUND_LOWER : TRIM_BOUND_UPPER;

    this.props.updateSelectedTrimBoundCreator(trimBound);
  };

  handleFlagMouseDown = () => {
    this.props.requestVideoPlayerPause();
  };

  handleFlagMouseLeave = half => {
    const trimBound =
      half === FLAG_LEFT_HALF ? TRIM_BOUND_LOWER : TRIM_BOUND_UPPER;

    if (this.props.selectedTrimBound === trimBound) {
      this.props.updateSelectedTrimBoundCreator(null);
    } else {
      this.props.updateSelectedTrimBoundCreator(trimBound);
    }
  };

  handleFlagUpdateTime = (e, flagHalf, suppliedTime = null) => {
    const currentTrimRange = { ...this.props.currentTrimRange };

    let newTime = suppliedTime;

    if (e != null && suppliedTime == null) {
      newTime = this.props.getNewTime(e) * 1000;
    }

    const isLeftFlag = flagHalf === FLAG_LEFT_HALF;

    const newCurrentTime = getNewTrimBoundTime(
      newTime,
      currentTrimRange,
      this.boundingRange,
      isLeftFlag,
      MIN_TRIM_RANGE_LENGTH
    );

    if (isLeftFlag) {
      currentTrimRange.from = newCurrentTime;
    } else {
      currentTrimRange.to = newCurrentTime;
    }

    this.props.updateCurrentTrimRangeCreator(currentTrimRange);
    this.props.requestVideoPlayerCurrentTime(newCurrentTime / 1000);
  };
}

const mapStateToProps = state => {
  const { duration } = state.video_player;

  const {
    current_trim_range: currentTrimRange,
    selected_trim_bound: selectedTrimBound,
    trim_ranges: trimRanges,
  } = state.trimming;

  return {
    currentTrimRange,
    duration,
    selectedTrimBound,
    trimRanges,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    requestVideoPlayerCurrentTime: currentTime =>
      dispatch(requestVideoPlayerCurrentTime(currentTime)),
    requestVideoPlayerPause: () => dispatch(requestVideoPlayerPause()),
    updateCurrentTrimRangeCreator: currentTrimRange =>
      dispatch(updateCurrentTrimRangeCreator(currentTrimRange)),
    updateSelectedTrimBoundCreator: trimBound =>
      dispatch(updateSelectedTrimBoundCreator(trimBound)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrimRangeEditBar);
